@media (max-width: 768px) {
  .large-header {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .small-header {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .modal-height-90 {
    --height: 90%;
  }
}

.modal-search-result {
  --padding-start: 0;
}

table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;

  overflow-y: hidden;
  overflow-x: auto;
  position: relative;
}

table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 6px;
}

table th {
  position: sticky;
  top: 0; /* required for the stickiness */

  text-align: start;
  background-color: #686767;
  padding: 8px !important; /* override styles from ionic */
  padding-left: 12px !important; /* override styles from ionic */
  padding-right: 12px !important; /* override styles from ionic */
  cursor: pointer;
}

table td ion-icon {
  color: #6f6f6f;
  font-size: 20px;
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

.sort-desc {
  background-image: url(/assets/icon/down-arrow.svg);
  background-position: bottom 10px right 6px;
  background-repeat: no-repeat;
  background-size: 14px 14px;
  padding-right: 28px !important; /* override styles from ionic */
}

.sort-asc {
  background-image: url(/assets/icon/up-arrow.svg);
  background-position: bottom 10px right 6px;
  background-repeat: no-repeat;
  background-size: 14px 14px;
  padding-right: 28px !important; /* override styles from ionic */
}

table td {
  padding: 12px !important; /* override styles from ionic */
}

table tr:nth-child(odd) {
  background-color: #292929;
}

tr:not(:first-child):hover {
  background-color: #454343;
  cursor: pointer;
}

.rfis-container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  padding-right: 15px;
}

.rfis-state {
  box-sizing: border-box;
  width: 100%;
  margin-top: 15px;
  min-width: 280px;
  overflow-y: auto;
  /*background-color: #292929;*/
  margin-left: 15px;
  height: fit-content;
}
@media (max-width: 500px) {
  .rfis-state {
    min-width: 85vw !important;
  }
}

.state-title {
  display: flex;
  justify-content: space-between;
  color: white;
}

.state-title h2 {
  padding-left: 20px;
  font-weight: normal;
  font-size: 14px;
}

.state-title span {
  padding: 18px;
}

.no-access-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  text-align: center;
  padding: 20px;
}
